<button
  *ngIf="!hideBtn"
  (click)="newAction()"
  [disabled]="disabled"
  class="btn"
  [ngClass]="type"
>
  <mat-icon
    *ngIf="useIcon"
    class="icon"
    [class.disabled]="disabled"
    >
    {{typeToIconMap[type]}}
  </mat-icon>
  <img
    class="img"
    *ngIf="!useIcon"
    [src]="typeToPathMap[type]"
  >

</button>
